import { Link, Outlet, useLocation } from 'react-router-dom';

export type PortalUser = { id: string; name: string; email: string; role: string; twoFactorEnabled: boolean };
export type PortalClient = {
  id: string;
  name: string;
  status: string;
  needsBillingAddress?: boolean;
};

export function PortalLayout({ user, client, onSignOut }: {
  user: PortalUser;
  client: PortalClient | null;
  onSignOut: () => void;
}) {
  const { pathname } = useLocation();
  // Asked once, at the top of every page, until it is answered — and not on
  // the page that answers it, where it would be telling someone to do the
  // thing they are already doing.
  const askForAddress = Boolean(client?.needsBillingAddress) && pathname !== '/portal/billing';

  return (
    <div className="simple-shell portal-shell">
      <header className="simple-topbar">
        <Link className="simple-brand" to="/portal"><span>W</span><strong>WebForGrowth</strong></Link>
        <div className="simple-context">{client?.name}</div>
        <div className="simple-account"><span>{user.name}</span><button className="secondary small" onClick={onSignOut}>Sign out</button></div>
      </header>
      {askForAddress && (
        <div className="portal-banner">
          <div>
            <strong>We need your billing address</strong>
            <span>It appears on your invoices and receipts. This takes a minute.</span>
          </div>
          <Link className="btn small" to="/portal/billing">Add billing address</Link>
        </div>
      )}
      <main className="simple-main"><Outlet /></main>
    </div>
  );
}
